import React, { useState, useEffect } from "react";
import "./CookieConsent.css";

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [necessaryChecked, setNecessaryChecked] = useState(true);
  const [analyticsChecked, setAnalyticsChecked] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowConsent(true);
    } else {
      try {
        if (consent === "all" || consent === "necessary") {
          const consentData = {
            necessary: true,
            analytics: consent === "all",
            timestamp: new Date().toISOString()
          };
          localStorage.setItem("cookieConsent", JSON.stringify(consentData));
          setNecessaryChecked(true);
          setAnalyticsChecked(consent === "all");
        } else {
          const consentData = JSON.parse(consent);
          setNecessaryChecked(consentData.necessary !== false);
          setAnalyticsChecked(consentData.analytics === true);
        }
      } catch (error) {
        console.warn("Cookie consent data corrupted, resetting...");
        localStorage.removeItem("cookieConsent");
        setShowConsent(true);
      }
    }
  }, []);

  const handleAcceptAll = () => {
    const consentData = {
      necessary: true,
      analytics: true,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem("cookieConsent", JSON.stringify(consentData));
    setShowConsent(false);
    
    if (window.gtag) {
      window.gtag("consent", "update", {
        "analytics_storage": "granted",
        "ad_storage": "denied",
        "functionality_storage": "granted",
        "personalization_storage": "denied"
      });
    }
  };


  const handleSaveSettings = () => {
    const consentData = {
      necessary: necessaryChecked,
      analytics: analyticsChecked,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem("cookieConsent", JSON.stringify(consentData));
    setShowConsent(false);
    
    if (window.gtag) {
      window.gtag("consent", "update", {
        "analytics_storage": analyticsChecked ? "granted" : "denied",
        "ad_storage": "denied",
        "functionality_storage": necessaryChecked ? "granted" : "denied",
        "personalization_storage": "denied"
      });
    }
  };

  const handleRejectAll = () => {
    const consentData = {
      necessary: true,
      analytics: false,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem("cookieConsent", JSON.stringify(consentData));
    setShowConsent(false);
    
    if (window.gtag) {
      window.gtag("consent", "update", {
        "analytics_storage": "denied",
        "ad_storage": "denied",
        "functionality_storage": "granted",
        "personalization_storage": "denied"
      });
    }
  };

  if (!showConsent) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-modal">
        {!showSettings ? (
          // Basit gorunum
          <div className="cookie-simple-view">
            <div className="cookie-text">
              <p>Web sitemizde size daha iyi hizmet verebilmek için çerezler kullanılmaktadır. <strong>Kabul Et</strong> seçeneği ile tüm çerezleri kabul edebilir veya <strong>Ayarlar</strong> seçeneği ile çerezler hakkında daha fazla bilgi alıp tercihlerinizi yönetebilirsiniz.</p>
              <a href="/cerez-politikasi" className="policy-link">Çerez Politikası</a>
            </div>
            <div className="cookie-buttons">
              <button className="btn-accept" onClick={handleAcceptAll}>
                Kabul Et
              </button>
              <button className="btn-settings" onClick={() => setShowSettings(true)}>
                Ayarlar
              </button>
            </div>
          </div>
        ) : (
          // Detayli gorunum
          <div className="cookie-detailed-view">
            <div className="cookie-header">
              <div className="cookie-title">
                <h3>Çerez İzleme Tercihleri</h3>
                <p>Lütfen Tercihlerinizi Yapınız</p>
              </div>
              <a href="/cerez-politikasi" className="policy-link-header">Çerez Politikası</a>
        </div>
        
            <div className="cookie-actions">
              <button className="btn-accept-all" onClick={handleAcceptAll}>
                Tümünü Kabul Et
              </button>
              <button className="btn-reject-all" onClick={handleRejectAll}>
                Tümünü Reddet
              </button>
            </div>

          <div className="cookie-categories">
            <div className="cookie-category">
              <div className="cookie-category-header">
                <div className="cookie-category-info">
                    <h4>Zorunlu Çerezler</h4>
                    <span className="required-badge">Zorunlu</span>
                  </div>
              </div>
            </div>

            <div className="cookie-category">
              <div className="cookie-category-header">
                <div className="cookie-category-info">
                    <h4>Performans Çerezleri</h4>
                </div>
                <label className="cookie-switch">
                  <input 
                    type="checkbox" 
                    checked={analyticsChecked}
                    onChange={(e) => setAnalyticsChecked(e.target.checked)}
                  />
                  <span className="slider"></span>
                </label>
              </div>
              </div>

              <div className="cookie-category">
                <div className="cookie-category-header">
                  <div className="cookie-category-info">
                    <h4>Fonksiyonel Çerezler</h4>
                  </div>
                  <label className="cookie-switch">
                    <input 
                      type="checkbox" 
                      checked={false}
                      disabled
                    />
                    <span className="slider"></span>
                  </label>
            </div>
          </div>

              <div className="cookie-category">
                <div className="cookie-category-header">
                  <div className="cookie-category-info">
                    <h4>Pazarlama Çerezleri</h4>
                  </div>
                  <label className="cookie-switch">
                    <input 
                      type="checkbox" 
                      checked={false}
                      disabled
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </div>
          </div>

            <div className="cookie-footer">
              <div className="cookie-brand">ProgenX</div>
              <button className="btn-save" onClick={handleSaveSettings}>
                Değişiklikleri Kaydet
            </button>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default CookieConsent;
